import React, { useContext } from 'react';
import { formatVodTimeText, PlayerUIContext } from '@24i/player-ui';
import { useAdsData, usePlayerTimes } from '@24i/player-utils-react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@24i/nxg-sdk-higgs/src/hooks/useTheme';
import { getFont } from '@24i/nxg-sdk-higgs/src/StyleSheet';
import { Title } from './styled';
const AdsCounter = ({ playerInstance, className, style }) => {
    var _a;
    const { state: { isVolumeOpened }, } = useContext(PlayerUIContext);
    const { isAdBreakActive, currentAdBreak, currentAd } = useAdsData(playerInstance);
    const { elapsedTime, durationTime } = usePlayerTimes(playerInstance);
    const { t } = useTranslation(['sott']);
    const { theme } = useTheme();
    const formattedTime = durationTime > 0 && elapsedTime <= durationTime
        ? formatVodTimeText(durationTime - elapsedTime, false)
        : '0:00';
    const text = t('player.advertisement.title', {
        adPosition: (_a = currentAd === null || currentAd === void 0 ? void 0 : currentAd.adPosition) !== null && _a !== void 0 ? _a : 1,
        totalAds: currentAdBreak === null || currentAdBreak === void 0 ? void 0 : currentAdBreak.totalAds,
        currentTime: formattedTime,
    });
    return isAdBreakActive && currentAdBreak ? (React.createElement(Title, { "data-test": "AdsCounter", className: `AdsCounter ${className}`, isVolumeOpened, style: Object.assign(Object.assign({}, getFont(theme, 'h5')), style), theme: theme }, text)) : null;
};
AdsCounter.defaultProps = {
    className: '',
    style: null,
};
export { AdsCounter };
//# sourceMappingURL=index.js.map